import { Input } from "@/components/ui/input";
import { Wallet } from "lucide-react";

const BRL = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const OPTIONS = [
  { key: "none", label: "Sem orçamento", hint: "Só aparece organicamente ou com Impulso" },
  { key: "daily", label: "Diário", hint: "Valor máximo gasto por dia" },
  { key: "total", label: "Por período", hint: "Valor total para a duração" },
];

/** Budget picker shared by the create/edit ad dialogs. `value` = { budget_type, daily_budget, total_budget, duration_days } */
export default function AdBudgetFields({ value, onChange, cpm = 19.9, walletBalance }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const amount = value.budget_type === "daily" ? Number(value.daily_budget || 0) : Number(value.total_budget || 0);
  const estImpressions = cpm > 0 ? Math.floor((amount / cpm) * 1000) : 0;
  const perDay = value.budget_type === "total" && Number(value.duration_days) > 0 ? amount / Number(value.duration_days) : amount;
  return (
    <div className="pt-3 border-t border-border space-y-2" data-testid="ad-budget-block">
      <div className="flex items-center justify-between gap-2">
        <div className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">Orçamento da campanha</div>
        {walletBalance != null && (
          <span className="text-[11px] text-muted-foreground inline-flex items-center gap-1" data-testid="ad-budget-wallet">
            <Wallet className="w-3 h-3" /> Saldo: <b>{BRL(walletBalance)}</b>
          </span>
        )}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {OPTIONS.map((o) => (
          <button
            key={o.key}
            type="button"
            onClick={() => set({ budget_type: o.key })}
            data-testid={`ad-budget-type-${o.key}`}
            className={`text-left p-2 rounded-lg border text-xs transition-colors ${value.budget_type === o.key ? "border-primary bg-primary/10" : "border-border hover:bg-muted"}`}
          >
            <div className="font-semibold">{o.label}</div>
            <div className="text-[10px] text-muted-foreground leading-tight">{o.hint}</div>
          </button>
        ))}
      </div>
      {value.budget_type === "daily" && (
        <div className="grid grid-cols-2 gap-2">
          <Input type="number" min={5} step="1" placeholder="R$ por dia (mín. 5)" value={value.daily_budget ?? ""} onChange={(e) => set({ daily_budget: e.target.value })} data-testid="ad-budget-daily" />
          <Input type="number" min={1} max={90} placeholder="Duração em dias (opcional)" value={value.duration_days ?? ""} onChange={(e) => set({ duration_days: e.target.value })} data-testid="ad-budget-duration" />
        </div>
      )}
      {value.budget_type === "total" && (
        <div className="grid grid-cols-2 gap-2">
          <Input type="number" min={10} step="1" placeholder="R$ total (mín. 10)" value={value.total_budget ?? ""} onChange={(e) => set({ total_budget: e.target.value })} data-testid="ad-budget-total" />
          <Input type="number" min={1} max={90} placeholder="Duração em dias *" value={value.duration_days ?? ""} onChange={(e) => set({ duration_days: e.target.value })} data-testid="ad-budget-duration" />
        </div>
      )}
      {value.budget_type !== "none" && amount > 0 && (
        <p className="text-[11px] text-muted-foreground" data-testid="ad-budget-estimate">
          ≈ <b>{estImpressions.toLocaleString("pt-BR")}</b> impressões {value.budget_type === "daily" ? "por dia" : "no período"} · CPM {BRL(cpm)}
          {value.budget_type === "total" && Number(value.duration_days) > 0 && <> · ≈ {BRL(perDay)}/dia</>}
          . Cobrado do saldo da carteira conforme as impressões acontecem; pausa automática ao atingir o limite.
        </p>
      )}
    </div>
  );
}
